import type { ReactNode } from 'react';

import { cn } from '../../lib/cn';
import styles from './Tabs.module.css';

export type TabItem<T extends string> = {
  readonly value: T;
  readonly label: string;
  readonly count?: number;
  readonly icon?: ReactNode;
};

export type TabsProps<T extends string> = {
  readonly items: readonly TabItem<T>[];
  readonly value: T;
  readonly onChange: (value: T) => void;
  readonly ariaLabel?: string;
};

export function Tabs<T extends string>({ items, value, onChange, ariaLabel = 'Разделы' }: TabsProps<T>) {
  return (
    <div role="tablist" aria-label={ariaLabel} className={styles['tabs']}>
      {items.map((item) => {
        const isActive = item.value === value;
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={cn(styles['tab'], isActive && styles['active'])}
            onClick={() => onChange(item.value)}
          >
            {item.icon}
            {item.label}
            {item.count === undefined ? null : <span className={styles['count']}>{item.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
